<template>
  <div class="report-ribbon" :style="backgroundStyle">
    <span>{{ title }}</span>
  </div>
</template>

<script>
import { REPORT_ASSETS } from '../reportAssets';

export default {
  name: 'ReportRibbon',
  props: {
    title: {
      type: String,
      required: true,
    },
  },
  computed: {
    backgroundStyle() {
      return {
        backgroundImage: ['url("', REPORT_ASSETS.moduleTitle, '")'].join(''),
      };
    },
  },
};
</script>

<style lang="scss" scoped>
.report-ribbon {
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 36vw;
  aspect-ratio: 800 / 114;
  box-sizing: border-box;
  padding: 0;
  margin: 0 0 1.5%;
  background-position: center;
  background-repeat: no-repeat;
  background-size: 100% 100%;
  color: #68311d;
  font-size: 13px;
  line-height: 1;
  font-weight: 700;
  text-align: left;
  break-after: avoid;
  page-break-after: avoid;
}

.report-ribbon span {
  width: 78%;
  text-align: center;
  white-space: nowrap;
}

@media print {
  .report-ribbon {
    width: 75.6mm;
  }
}
</style>
